export const AdventureLogo = ({ variant = "default" }: { variant?: "default" | "light" }) => {
  const isLight = variant === "light";
  const bottomLeftColor = isLight ? "#F8F5EE" : "#000000";
  const textColor = isLight ? "#F8F5EE" : "#050529";

  return (
    <div className="flex items-center gap-3 cursor-pointer group">
      <div className="relative w-8 h-8">
        <div
          className="absolute top-0 left-0 w-4 h-4 bg-[#5832D1] transition-transform duration-250 ease-[cubic-bezier(0.25,0,0.25,1)] group-hover:-translate-x-0.5 group-hover:-translate-y-0.5 group-hover:-rotate-5"
        />
        <div
          className="absolute top-0 right-0 w-4 h-4 bg-[#E0433E] transition-transform duration-250 ease-[cubic-bezier(0.25,0,0.25,1)] group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:rotate-5"
        />
        <div
          className="absolute bottom-0 left-0 w-4 h-4 transition-transform duration-250 ease-[cubic-bezier(0.25,0,0.25,1)] group-hover:-translate-x-0.5 group-hover:translate-y-0.5 group-hover:rotate-5"
          style={{ backgroundColor: bottomLeftColor }}
        />
      </div>

      <span className="text-2xl tracking-[-0.03em] font-medium" style={{ color: textColor }}>
        AdVenture
      </span>
    </div>
  );
};
